import { createRouter, createWebHistory } from 'vue-router';

import commonRoutes from '@/router/common';
import { buildAdminRoutes } from '@/utils/common';
import { STORAGE_KEYS } from '@/utils/constants/storage';
import { injectExtraMenus } from '@/utils/constants/menuExtras';
import Layout from '@/views/admin/layout/layout.vue';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            name: '/login',
            redirect: '/login'
        },
        {
            path: '/passwordReset',
            name: 'PasswordReset',
            component: () => import('@/views/common/passwordReset.vue')
        },
        ...commonRoutes
    ]
});

function ensureAdminRoutesFromStorage() {
    if (router.hasRoute('admin')) return true;

    const menuListStr = window.localStorage.getItem(STORAGE_KEYS.MENU_LIST);
    const home = window.localStorage.getItem(STORAGE_KEYS.HOME) as string | null;

    if (!menuListStr || !home) return false;

    const menuList = JSON.parse(menuListStr);
    if (!Array.isArray(menuList) || menuList.length === 0) return false;

    // 隐藏路由（消息中心 / 审批中心）不在后端菜单里，重建路由前先注入，
    // 保证硬刷新落在隐藏路由时也能命中（注入幂等：已存在不会重复 push）
    injectExtraMenus(menuList);

    const menus = menuList.map((item: any) => item.menuList).flat();
    const routes = buildAdminRoutes(menus || []);

    router.addRoute({
        path: '/admin',
        name: 'admin',
        component: Layout,
        redirect: home,
        children: routes
    });

    return true;
}

router.beforeEach((to) => {
    const token = window.localStorage.getItem(STORAGE_KEYS.TOKEN);

    if (to.path.startsWith('/admin')) {
        if (!token) {
            return { path: '/login', query: { redirect: to.fullPath } };
        }
    }

    // 动态菜单的绝对子路径（如 /workflow、/wfDef、/returnRepairOrder）不以 /admin 开头：
    // 冷启动/刷新直接落在这些路径时，同样需要从菜单缓存重建 admin 路由，否则命中 catch-all 404
    if (token && !router.hasRoute('admin')) {
        const registered = ensureAdminRoutesFromStorage();
        if (registered && to.matched.length === 0) {
            return to.fullPath;
        }
    }

    return true;
});

/**
 * 修复发版之前用户已经打开LNG云，发版之后用户操作切换页面没有反应的问题（底层原因就是动态按需加载的资源（js文件）已经不存在了被发版覆盖了）
 */
router.onError((error, to) => {
    if (
        error.message.includes('Failed to fetch dynamically imported module') ||
        error.message.includes('Importing a module script failed')
    ) {
        if (!to?.fullPath) {
            window.location.reload();
        } else {
            window.location = to.fullPath as any;
        }
    }
});

export { ensureAdminRoutesFromStorage };
export default router;
